import React, { useEffect, useState, useCallback } from "react";
import { Sidebar } from "primereact/sidebar";
import Card from "../pipelineComponents/Card";
import FollowUpsService from "../Services/FollowUpsService";
import DealService from "../Services/DealService.js";
import DashedCircleLoader from "../pipelineComponents/DashedCircleLoader";
import { formatDate, getIcons } from "../Constant/Constant";
import { followUpsStages } from "../../Enum/FollowUpsEnumConstants";
import { dealStagesData } from "../../Enum/PipelineEnumConstants";
import DealInfoCard from "../pipelineComponents/DealInfoCard.jsx";
import ViewAdvanceAmountCard from "../pipelineComponents/ViewAdvanceAmountCard.jsx";
import DailyUpdateCommentCard from "../pipelineComponents/DailyUpdateCommentCard.jsx";
import DealHistoryCard from "../pipelineComponents/DealHistoryCard.jsx";
import SiteVisitHistoryCard from "../pipelineComponents/SiteVisitHistoryCard.jsx";
import { showErrorToast } from "../Constant/Notification.js";
import { bookingPaymentType } from "../../Enum.js";
import { teamDetails, teamIds, userRole, userUid } from "../../utils/storage";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../App.css";
import { ToastContainer } from "react-toastify";
import ViewSiteImageModel from "../pipelineComponents/ViewSiteImageModel.jsx";
import { FaChevronLeft } from "react-icons/fa";
import DealNotesHistory from "../pipelineComponents/DealNotesHistory.jsx";

const DealFollowUpsList = ({ 
  startDate, 
  endDate, 
  userList, 
  selectedTeam, 
  setSelectedTeam, 
  selectedUser,
  setSelectedUser,
  refreshTrigger
}) => {
  const [stageData, setStageData] = useState({
    "FOLLOW UPS": { data: [], count: 0, next: "", loading: false, hasMore: true },
    "NO UPDATE": { data: [], count: 0, next: "", loading: false, hasMore: true },
  });
  
  const [teamList, setTeamList] = useState([]);
  const [overAllCount, setOverAllCount] = useState({});
  const [bodSelectedUser, setBodSelectedUser] = useState(null);
  const [visibleRight, setVisibleRight] = useState(false);
  const [dealInfoSelected, setDealInfoSelected] = useState({});
  const [dealStageSelected, setDealStageSelected] = useState("");
  const [dealID, setDealID] = useState(null);
  const [dealHistoryVisible, setDealHistoryVisible] = useState(false);
  const [viewAdvanceVisible, setViewAdvanceVisible] = useState(false);
  const [dailyUpdateComment, setDailyUpdateComment] = useState(false);
  const [sitevisitHistoryVisible, setSitevisitHistoryVisible] = useState(false);
  const [events, setEvents] = useState([]);
  const [selectedDealData, setSelectedDealData] = useState(null);
  const [selectedDealCommentsList, setSelectedDealCommentsList] = useState([]);
  const [sitevisitHistory, setSitevisitHistory] = useState([]);
  const [transactionData, setTransactionData] = useState([]);
  const [selectedPaymentType, setSelectedPaymentType] = useState([]);
  const [isDealNotesHistoryVisible, setIsDealNotesHistoryVisible] = useState(false);

    const [isOpenModalSiteImages, setIsOpenModalSiteImages] = useState(false);
    const [siteVisitImages, setSiteVisitImages] = useState([]);
  
  const icons = getIcons();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const localUserRole = userData?.user?.role;

  const isBoD = userRole === "BOD";
  const isMD = userRole === "MD";
  const currentSelectedId = isBoD ? bodSelectedUser : selectedTeam;
  const currentSelectedUser = isBoD ? bodSelectedUser : selectedUser;

  const getTeamList = async () => {
    try {
     let body = {};
  
      if (isMD) {
        body = {
          startDate: formatDate(startDate),
          endDate: formatDate(endDate),
          userId: userUid,
          role: userRole,
        };
      } else {
        body = {
          startDate: formatDate(startDate),
          endDate: formatDate(endDate),
          role: userRole,
        };
      }
  
      const teamIdList = Array.isArray(teamDetails)
        ? teamDetails.map((team) => team.id)
        : [];
  
      if (isBoD && teamIdList.length > 0) {
        body.teamId = teamIdList[0];
      }
  
      const response = isBoD
        ? await FollowUpsService.getFollowUpsDealsUser(body)
        : await FollowUpsService.getFollowUpsDealTeams(body);
  
      const responseData = response.data;
  
      let filterData = [];
      if (isMD && responseData.teamCounts) {
        filterData = responseData.teamCounts.filter((item) =>
          teamIdList.includes(item.id)
        );
      }
  
      setTeamList(
        isBoD
          ? responseData.userCounts
          : isMD
          ? filterData
          : responseData.teamCounts
      );
  
      setOverAllCount(responseData.overAllCount);
    } catch (error) {
      console.error(`Error fetching ${isBoD ? "users" : "teams"}:`, error);
    }
  };

  const showDealInfo = async (taskData, column) => {
    try {
      const dealInfo = await DealService.showDealInfo(taskData.id);
      setDealID(taskData.id);
      setSelectedDealData(dealInfo.data);
      setSelectedDealCommentsList(dealInfo.data.commentsList);
      setDealStageSelected(taskData.stage);
      setDealInfoSelected(dealInfo.data);
      setVisibleRight(true);
    } catch (error) {
      showErrorToast(error.message);
    }
  };

  const handleOpenSiteVisitHistory = async () => {
    setVisibleRight(false);
    setSitevisitHistoryVisible(true);
    try {
      const response = await DealService.sitevisitHistory(dealID);
      const history = response.data.history.map((item) => ({
        responsible: item.responsible,
        property: item.property,
        timestamp: item.visitTime
          ? `${new Date(item.visitTime).toLocaleDateString("en-GB")} ${new Date(item.visitTime).toLocaleTimeString("en-US", {
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
              hour12: true,
            })}`
          : "N/A",
      }));
      setSitevisitHistory(history);
    } catch (error) {
      showErrorToast(error.message);
    }
  };

  const handleCloseSiteVisitHistory = () => {
    setSitevisitHistoryVisible(false);
    setVisibleRight(true);
  };

  const handleDealHistory = async () => {
    setVisibleRight(false);
    setDealHistoryVisible(true);
    try {
      const response = await DealService.dealHistory(dealID);
      const history = response.data.history.map((item) => ({
        log: item.log,
        timestamp: item.timeStamp,
      }));
      setEvents(history);
    } catch (error) {
      showErrorToast(error.message);
    }
  };

  const handleDealHistoryBack = () => {
    setDealHistoryVisible(false);
    setVisibleRight(true);
  };

  const handleViewAdvancePayment = () => {
    setVisibleRight(false);
    setViewAdvanceVisible(true);
  };

  const fetchTransactionData = async () => {
    try {
      const response = await DealService.showDealInfo(dealID);
      setTransactionData(response.data.advancePaymentList);
    } catch (error) {
      showErrorToast(error.message);
    }
  };

  useEffect(() => {
    if (viewAdvanceVisible) {
      fetchTransactionData();
    }
  }, [viewAdvanceVisible]);

  const handleAdvancePaymentBack = () => {
    setViewAdvanceVisible(false);
    setVisibleRight(true);
  };

  const handleDailyUpdateComment = () => {
    setDailyUpdateComment(true);
    setVisibleRight(false);
  };

  const handleDailyUpdateCommentBack = () => {
    setDailyUpdateComment(false);
    setVisibleRight(true);
  };

  const handleFilterPaymentType = (e) => {
    setSelectedPaymentType(e.target.value);
  };

  const filteredTransactions = transactionData.filter(
    (advancePayment) =>
      selectedPaymentType.length === 0 ||
      selectedPaymentType.includes(advancePayment.advanceAmountPaymentType)
  );


  const totalReceivedAmountOfPaymentType1 = selectedDealData?.advancePaymentList.reduce(
    (total, value) => {
      if (value?.paymentDefinition === 1) {
        return total + (value?.amountReceived || 0);
      }
      return total;
    },
    0
  );

  const totalReceivedAmountOfPaymentType2 = selectedDealData?.advancePaymentList.reduce(
    (total, value) => {
      if (value?.paymentDefinition === 2) {
        return total + (value?.amountReceived || 0);
      }
      return total;
    },
    0
  );

  const totalReceivedAmountOfPaymentType3 = selectedDealData?.advancePaymentList.reduce(
    (total, value) => {
      if (value?.paymentDefinition === 3) {
        return total + (value?.amountReceived || 0);
      }
      return total;
    },
    0
  );

  const totalReceivedAmount =
    totalReceivedAmountOfPaymentType1 -
    totalReceivedAmountOfPaymentType2 -
    totalReceivedAmountOfPaymentType3;

  const totalCostOfProperty = selectedDealData?.budget;
  const totalCostOfPropertyWithRegistration =
    selectedDealData?.budget +
    (selectedDealData?.registrationPayments?.totalRegistrationAmount || 0);
  let pendingAmount = totalCostOfPropertyWithRegistration - totalReceivedAmount;
  pendingAmount = pendingAmount > 0 ? pendingAmount : 0;

  let excessAmount =
    totalCostOfPropertyWithRegistration -
    totalReceivedAmount +
    totalReceivedAmountOfPaymentType2;
  excessAmount = excessAmount < 0 ? Math.abs(excessAmount) : 0;

  const fetchStageData = async (stageValue, nextToken = "", isLoadMore = false) => {
    try {
      setStageData((prev) => ({
        ...prev,
        [stageValue]: { ...prev[stageValue], loading: true },
      }));

      const body = {
        limit: 10,
        next: nextToken,
        direction: isLoadMore ? "next" : "",
        startDate: formatDate(startDate),
        endDate: formatDate(endDate),
        followUpsType: stageValue,
         role :  userRole
      };

     
      if (isBoD) {
              body.teamId = teamIds[0];
              body.userId = currentSelectedUser;
            } else if (isMD) {
               body.mdUid = userUid
            } else {
              body.teamId = currentSelectedId || "";
              body.userId = currentSelectedUser?.value || "";
            }

      const response = await FollowUpsService.getFolloUpsDeal(body);
      const { data, count, next } = response.data;

      const transformedData = data.map((item) => ({
        id: item.id,
        squareFeet: `${item.squareFeet} Sq feet`,
        approx: ["Plot Booked", "Advance Amount Update", "Fully Registered", "Registration InProgress", "Deal Lost After Booking"].includes(item.currentStage)
          ? "Fixed"
          : "Approx",
        status: item.scheduleStatus || "",
        customerName: item.lead,
        siteName: item.property,
        propertyId: item.propertyId,
        stage: item.currentStage,
        teamMemberName: item.responsiblePerson?.name,
        teamDetail: item.team,
        teamId: item.teamId,
        day: item.scheduledDate || "",
        time: item.scheduledTime || "",
        bookedTimestamp: item.bookedDaysCount,
        recentComment: item.lastComment,
      }));

      setStageData((prev) => ({
        ...prev,
        [stageValue]: {
          data: isLoadMore ? [...prev[stageValue].data, ...transformedData] : transformedData,
          count: count[stageValue] || 0,
          next: next || "",
          loading: false,
          hasMore: !!next,
        },
      }));
    } catch (error) {
      console.error(`Error fetching ${stageValue}:`, error);
      setStageData((prev) => ({
        ...prev,
        [stageValue]: { ...prev[stageValue], loading: false },
      }));
    }
  };

  const loadAllStages = async () => {
    const filterStage = followUpsStages.filter((stage) => stage.value !== "FOLLOWED BACK");
    const promises = filterStage.map((stage) => fetchStageData(stage.value));
    await Promise.all(promises);
  };

  useEffect(() => {
    getTeamList();
  }, [startDate, endDate, userUid]);

  useEffect(() => {
    setStageData({
      "FOLLOW UPS": { data: [], count: 0, next: "", loading: false, hasMore: true },
      "NO UPDATE": { data: [], count: 0, next: "", loading: false, hasMore: true },
    });
    loadAllStages();
  }, [selectedTeam, startDate, endDate, bodSelectedUser ,refreshTrigger ,selectedUser]);

  const handleScroll = useCallback(
    (e, stageValue) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollHeight - scrollTop <= clientHeight + 100) {
        const stage = stageData[stageValue];
        if (stage.hasMore && !stage.loading) {
          fetchStageData(stageValue, stage.next, true);
        }
      }
    },
    [stageData]
  );

  const handleTeamSelection = (teamId) => {
    if (isBoD) {
      setBodSelectedUser(bodSelectedUser === teamId ? null : teamId);
    } else {
      setSelectedTeam(selectedTeam === teamId ? null : teamId);
      setSelectedUser(null); 
    }
  };

  const handleViewSiteImages = async (dealId) => {
    try {
      const response = await DealService.fetchDealImages(dealId);
      if (response) {
        setSiteVisitImages(response?.data?.dealImages);
        setIsOpenModalSiteImages(true);
        setVisibleRight(false);
      }
    } catch (err) {
      console.log(err);
      showErrorToast(err.message);
    }
  };

  const handleAllSelection = () => {
    if (isBoD) {
      setBodSelectedUser(null);
    } else {
      setSelectedTeam(null);
      setSelectedUser(null);
    }
  };

  const renderStageColumn = (stageKey, title, bgColor, borderColor, iconColor) => {
    const stage = stageData[stageKey];

    return (
      <div className="flex flex-col gap-4">
        <div className="text-[24px] font-medium">
          {title} ({stage.count})
        </div>
        <div
          className="bg-white p-3 h-[calc(100vh-270px)] overflow-y-auto w-[367px] rounded-[10px] shadow"
          onScroll={(e) => handleScroll(e, stageKey)}
        >
          {stage.data.map((task, index) => (
            <div
              key={task.id}
              onClick={() => showDealInfo(task, { title: stageKey })}
              className="flex mb-4 cursor-pointer items-start gap-4 rounded-[10px]"
            >
              <Card
                title={task.siteName || "Site Name"}
                task={task}
                dealId={task.id}
                index={index}
              />
            </div>
          ))}
          {stage.data.length === 0 && !stage.loading && (
            <div className="flex flex-col items-center justify-center h-full">
              <img src={icons.emptyFollowUp} alt="No Data" className="w-40 h-40" />
              <div className="text-gray-500 text-lg mt-4">
                 {title === "Follow Ups" ? "No Follow Ups Available" : "No Updates Available"}
              </div>
            </div>
          )}
          {stage.loading && (
            <div className="flex justify-center py-4">
              <DashedCircleLoader />
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderTeamSelectionColumn = () => {
    const selectionTitle = isBoD ? "Select User" : "Select Team";
    const allSelectionText = isBoD ? "All Users" : "All Teams";
    
    return (
      <div className="flex flex-col gap-4">
        <div className="text-[24px] font-medium">{selectionTitle}</div>
        <div className="bg-white relative h-[calc(100vh-270px)] overflow-y-auto w-[370px] rounded-[10px] shadow">
          
          {/* All Selection Option */}
          {overAllCount && (
            <div
              onClick={handleAllSelection}
              className={`p-3 rounded-lg mx-3 mt-3 top-0 sticky flex items-center justify-between mb-4 cursor-pointer transition-all duration-200 ${
                currentSelectedId === null
                  ? "bg-blue-50 border-2 border-blue-200 shadow-sm"
                  : "bg-gray-50 border border-gray-200 hover:bg-gray-100"
              }`}
            >
              <div className="text-base font-medium cursor-pointer truncate w-40">
                {allSelectionText}
              </div>
              <div className="flex items-center gap-2">
                <div className="flex items-center rounded-full bg-blue-50 border border-blue-200 h-8 w-8 text-center justify-center text-blue-600 text-sm font-medium">
                  {overAllCount.followUps || 0}
                </div>
                <div className="flex items-center rounded-full bg-orange-50 border border-orange-200 h-8 w-8 text-center justify-center text-orange-600 text-sm font-medium">
                  {overAllCount.noUpdate || 0}
                </div>
              </div>
            </div>
          )}

          {/* Individual Team/User Items */}
          {teamList.map((item) => (
            <div
              key={item.id}
              onClick={() => handleTeamSelection(item.id)}
              className={`p-3 rounded-lg m-3 flex items-center justify-between mb-4 cursor-pointer transition-all duration-200 ${
                currentSelectedId === item.id
                  ? "bg-blue-50 border-2 border-blue-200 shadow-sm"
                  : "bg-gray-50 border border-gray-200 hover:bg-gray-100"
              }`}
            >
              <div className="text-base font-medium cursor-pointer truncate w-40">
                {item.name}
              </div>
              <div className="flex items-center gap-2">
                <div className="flex items-center rounded-full bg-blue-50 border border-blue-200 h-8 w-8 text-center justify-center text-blue-600 text-sm font-medium">
                  {item.counts?.followUps || 0}
                </div>
                <div className="flex items-center rounded-full bg-orange-50 border border-orange-200 h-8 w-8 text-center justify-center text-orange-600 text-sm font-medium">
                  {item.counts?.noUpdate || 0}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="h-screen overflow-x-auto pb-4 custom-scrollbar pipeline flex gap-6">
      <ToastContainer />
      
    
      {renderTeamSelectionColumn()}

      {renderStageColumn(
        "FOLLOW UPS",
        "Follow Ups",
        "bg-blue-50",
        "border border-blue-200",
        "text-blue-600"
      )}
      {renderStageColumn(
        "NO UPDATE",
        "No Update",
        "bg-orange-50",
        "border border-orange-200",
        "text-orange-600"
      )}

      <Sidebar
        visible={visibleRight}
        position="right"
        onHide={() => setVisibleRight(false)}
      >
        <DealInfoCard
          icons={icons}
          dealID={dealID}
          dealInfoSelected={dealInfoSelected}
          dealStageSelected={dealStageSelected}
          showDealInfo={showDealInfo}
          setVisibleRight={setVisibleRight}
          handleViewAdvanvcePayment={handleViewAdvancePayment}
          handleDailyUpdateComment={handleDailyUpdateComment}
          handleOpenSiteVisitHistory={handleOpenSiteVisitHistory}
          handleDealHistory={handleDealHistory}
          handleDealNotesHistory={() => {
            setIsDealNotesHistoryVisible(true);
            setVisibleRight(false);
          }}
          userRole={localUserRole}
          userList={userList}
          dealStagesData={dealStagesData}
          handleViewSiteImages = { handleViewSiteImages }
          onReload={loadAllStages}
        />
      </Sidebar>

      <Sidebar
        visible={viewAdvanceVisible}
        position="right"
        onHide={() => setViewAdvanceVisible(false)}
      >
        <ViewAdvanceAmountCard
          handleFilterPaymentType={handleFilterPaymentType}
          selectedDealData={selectedDealData}
          handleAdvancePaymentBack={handleAdvancePaymentBack}
          selectedPaymentType={selectedPaymentType}
          bookingPaymentType={bookingPaymentType}
          totalCostOfProperty={totalCostOfProperty}
          totalReceivedAmount={totalReceivedAmount}
          pendingAmount={pendingAmount}
          excessAmount={excessAmount}
          totalReceivedAmountOfPaymentType3={totalReceivedAmountOfPaymentType3}
          dealStageSelected={dealStageSelected}
          filteredTransactions={filteredTransactions}
          dealStagesData={dealStagesData}
        />
      </Sidebar>

      <Sidebar
        visible={dailyUpdateComment}
        position="right"
        onHide={() => setDailyUpdateComment(false)}
      >
        <DailyUpdateCommentCard
          handleDailyUpdateCommentBack={handleDailyUpdateCommentBack}
          selectedDealCommentsList={selectedDealCommentsList}
        />
      </Sidebar>

       <Sidebar
              visible={isDealNotesHistoryVisible}
              position="right"
              header={
                <div className="flex items-center font-bold text-lg">
                  <FaChevronLeft
                    className="cursor-pointer text-xl text-customGreen"
                    onClick={() => {
                      setIsDealNotesHistoryVisible(false);
                      setVisibleRight(true);
                    }}
                  />
                  &nbsp; Deal Notes History
                </div>
              }
              onHide={() => {
                setIsDealNotesHistoryVisible(false);
                setVisibleRight(true);
              }}
            >
              <DealNotesHistory dealId={dealID} />
            </Sidebar>

      <Sidebar
        visible={dealHistoryVisible}
        position="right"
        onHide={() => setDealHistoryVisible(false)}
      >
        <DealHistoryCard
          events={events}
          handleDealHistoryBack={handleDealHistoryBack}
        />
      </Sidebar>

      <Sidebar
        visible={sitevisitHistoryVisible}
        position="right"
        onHide={() => setSitevisitHistoryVisible(false)}
      >
        <SiteVisitHistoryCard
          sitevisitHistory={sitevisitHistory}
          handleCloseSiteVisitHistory={handleCloseSiteVisitHistory}
        />
      </Sidebar>

      <ViewSiteImageModel
              data={siteVisitImages}
              isOpenModal={isOpenModalSiteImages}
              onClose={() => {
                setIsOpenModalSiteImages(false);
                setVisibleRight(true);
              }}
            />
    </div>
  );
};

export default DealFollowUpsList;